module.exports = __webpack_public_path__ + "static/media/treasure-chest.6ae1e746.svg";